export default () => {
  const page = document.querySelector("html");
  const overlay = document.querySelector(".overlay");
  const burger = document.querySelector(".burger");
  const header = document.querySelector(".header__content");
  const navLinks = document.querySelectorAll(".nav__link");

  burger.addEventListener("click", function () {
    page.classList.toggle("active");
    overlay.classList.toggle("active");
    burger.classList.toggle("header__burger--active");
    header.classList.toggle("header__content--active");
  })

  for (let i = 0; i < navLinks.length; i++) {
    navLinks[i].addEventListener("click", closeMenu);
  }

  overlay.addEventListener("click", closeMenu);
  window.addEventListener("resize", checkMenu);

  function closeMenu() {
    page.classList.remove("active");
    overlay.classList.remove("active");
    burger.classList.remove("header__burger--active");
    header.classList.remove("header__content--active");
  }

  function checkMenu() {
    if (document.documentElement.clientWidth > 767) {
      closeMenu();
    }
  }
};
